import React, { FC } from 'react';
import AUSpinnerComponent from '@aarhus-university/au-lib-react-components/src/components/AUSpinnerComponent';
import { useGetServiceQuery } from '../services/api';

// get lang from html lang attribute
const lang = document.documentElement.lang || 'da';

const ResultComponent: FC<ResultComponentProps> = ({
  search,
}: ResultComponentProps) => {
  const { data, isLoading, isFetching } = useGetServiceQuery(search);

  const renderServiceAreas = (results: IService[]) => (
    results.map((service) => service.SubAreas.map((area) => area.ServiceItems)).flat(2) || []
  ).map((item) => {
    const renderPersons = item.Persons.map((person) => (
      <li key={person.Id}>
        <div className="service-areas__results__person">
          <div className="service-areas__results__person__contact-info">
            <h4>{person.FullName}</h4>
            {
              person.Departments.map((department) => (
                <div key={department.Id} className="service-areas__results__person__department">
                  <h5>{department.Name}</h5>
                  <address>
                    {`${department.Address.Street}, ${department.Address.Zip} ${department.Address.City}`}
                    <br />
                    <a href={`mailto:${department.Email}`}>{department.Email}</a>
                    <br />
                    <a href={`tel:${department.Mobile}`}>{department.Mobile}</a>
                  </address>
                </div>
              ))
            }
          </div>
          {
            person.Photo && (
              <img className="profile-image" src={person.Photo} alt={person.FullName} />
            )
          }
        </div>
      </li>
    ));

    return (
      <li key={item.Name} className="service-areas__results__item">
        <h3>{item.Name}</h3>
        {
          item.Persons.length === 0 && (
            <p>
              {
                item.ContactInformation.startsWith('http') ? (
                  <a href={item.ContactInformation} target="_blank" rel="noreferrer">
                    {item.ContactInformation}
                  </a>
                ) : (
                  item.ContactInformation
                )
              }
              {
                item.SecondaryContactInformation && (
                  <>
                    <br />
                    {item.SecondaryContactInformation}
                  </>
                )
              }
              {
                item.AdditionalInformation && (
                  <>
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: item.AdditionalInformation }} />
                  </>
                )
              }
            </p>
          )
        }
        {
          item.Persons.length > 0 && (
            <ul className="resetlist">
              {renderPersons}
            </ul>
          )
        }
      </li>
    );
  });

  return (
    <AUSpinnerComponent
      loaded={!isLoading || !isFetching}
    >
      <div className="row">
        <div className="column large-6 medium-6 small-12">
          <div className="service-areas__results">
            <h2 className="service-icon">
              {lang === 'en' ? 'Service' : 'Bygningsdrift'}
            </h2>
            {
              ((data?.Service[0]?.SubAreas || []).length > 0) ? (

                <ul className="service-areas__results__items resetlist">
                  {renderServiceAreas(data?.Service || [])}
                </ul>
              ) : (
                <p>{lang === 'en' ? 'No results found.' : 'Ingen resultater fundet.'}</p>
              )
            }
          </div>
        </div>
        <div className="column large-6 medium-6 small-12">
          <div className="service-areas__results">
            <h2 className="cleaning-icon">
              {lang === 'en' ? 'Cleaning' : 'Rengøring'}
            </h2>
            {
              ((data?.Cleaning[0]?.SubAreas || []).length > 0) ? (
                <ul className="service-areas__results__items resetlist">
                  {renderServiceAreas(data?.Cleaning || [])}
                </ul>
              ) : (
                <p>{lang === 'en' ? 'No results found.' : 'Ingen resultater fundet.'}</p>
              )
            }
          </div>
        </div>
      </div>
    </AUSpinnerComponent>
  );
};

ResultComponent.displayName = 'ResultComponent';
export default ResultComponent;
